import {
  AnalyticsAction,
  AnalyticsObjectType,
  AnalyticsParentPage,
  AnalyticsPlacementType,
  AnalyticsSubPage,
} from '@chewy/loyalty-common/constants';
import { buildLoyaltyAnalyticsEvent } from '@chewy/loyalty-common/utils';

export enum MembershipDashboardPlacementDetail {
  Faq = 'faq',
  FreeSamplesCard = 'free_samples_card',
  FreeShippingCard = 'free_shipping_card',
  FreeShippingSheet = 'free_shipping_sheet',
  ManageMembershipLink = 'manage_membership_link',
  MemberBenefitsWidget = 'member_benefits_widget',
  MembershipHeader = 'membership_header',
  MembershipPage = 'membership_page',
  MorePerksCard = 'more_perks_card',
  PetPoisonHelplineCard = 'pet_poison_helpline_card',
  PetPoisonHelplineSheet = 'pet_poison_helpline_sheet',
  RewardsCard = 'rewards_card',
  RewardsSheet = 'rewards_sheet',
  VirtualVetCard = 'virtual_vet_card',
  VirtualVetSheet = 'virtual_vet_sheet',
}

interface MembershipDashboardAnalyticsEventInput {
  action: AnalyticsAction;
  objectType: AnalyticsObjectType;
  placementDetail: MembershipDashboardPlacementDetail;
  subPage?: AnalyticsSubPage;
}

export const buildMembershipDashboardAnalyticsEvent = ({
  action,
  objectType,
  placementDetail,
  subPage = AnalyticsSubPage.None,
}: MembershipDashboardAnalyticsEventInput) => {
  const event = buildLoyaltyAnalyticsEvent({
    action,
    objectType,
    parentPage: AnalyticsParentPage.Membership,
    placementDetail,
    placementType: AnalyticsPlacementType.Membership,
    subPage,
  });

  return {
    data: {
      ...event.data,
      extraData: { experienceVersion: 'v4' },
    },
    eventName: event.eventName,
  };
};
